import {
  LOAD_METER_MODEL_LIST,
  LOAD_METER_ZIP_UPLOAD_HISTORY,
  UPLOAD_METER_ZIP_REQUEST,
  UPLOAD_METER_ZIP_SUCCESS,
  GENERIC_MESSAGE,
  GENERIC_FAILED_ERROR,
  METER_ZIP_UPLOAD_ERROR,
  LOAD_METER_HISTORY_REQUEST,
  LOAD_METER_HISTORY_SUCCESS,
  LOAD_METER_HISTORY_FILTERS_SUCCESS,
  LOAD_METER_HISTORY_ERROR,
  EMPTY_METER_ZIP_UPLOAD_HISTORY,
  METER_UPLOAD_INSTANCE_LIST_AND_ZIP_SIZE_LIMIT
} from "../MeteringUpload/MeteringUploadConstants";
import AppService from "Global/AppService";
import { getMeterZipUploadHistoryListURL } from "ECD/NGIApiUrls";

export const loadMeterModelList = (url) => {
  return (dispatch) => {
    function callbackOnLoadMeterModelList(success, err) {
      if (success && success.result) {
        let models = success.result;
        const modelList = models.map((item) => ({
          label: item,
          value: item,
        }));

        dispatch({
          type: LOAD_METER_MODEL_LIST,
          newState: { meterModelList: modelList },
        });
      }
    }
    AppService.getData(url, callbackOnLoadMeterModelList);
  };
};

export const loadMeterZipUploadHistory = (url, payload, onApplyClick) => {
  return (dispatch) => {
    dispatch(loadMeterHistoryRequest(onApplyClick));
    function callbackOnLoadMeterZipUploadHistory(success, err,responseCode) {
      if (success && success.result) {
        dispatch(loadMeterHistorySuccess(success.result, onApplyClick));
      } else {
        dispatch(loadMeterHistoryError(err, responseCode));
      }
    }
    AppService.postData(payload, url, callbackOnLoadMeterZipUploadHistory);
  };
};

export const uploadMeterZip = (formData, url) => {
  return (dispatch) => {
    dispatch(uploadMeterZipRequest());

    function callback(success, err, responseCode) {
      if (success && success.result) {       
        dispatch(uploadMeterZipSuccess(success.result));
      } else {
        dispatch(uploadMeterZipError(err, responseCode));
      }
      dispatch({ type: EMPTY_METER_ZIP_UPLOAD_HISTORY, newState: { meterZipUploadHistoryList: [] } });
      let payload = {
        "selectedInstances": [],
        "selectedSerialNumbers": []
      }
      dispatch(
        loadMeterZipUploadHistory(getMeterZipUploadHistoryListURL(0).url, payload, false)
      );
    }
    AppService.postDataWithoutTimeOut(formData, url, callback);
  };
};

const uploadMeterZipRequest = () => {
  return {
    type: UPLOAD_METER_ZIP_REQUEST,
  };
};

const uploadMeterZipSuccess = (result) => {
  return {
    type: UPLOAD_METER_ZIP_SUCCESS,
    payload: result,
  };
};

const uploadMeterZipError = (err) => {
  let message = GENERIC_FAILED_ERROR;
  if (err?.status == 500) {
    message = err?.responseJSON?.message || GENERIC_MESSAGE;
  } else if (err?.status == 400) {
    message = err?.responseJSON?.message || GENERIC_MESSAGE;
  }
  return {
    type: METER_ZIP_UPLOAD_ERROR,
    payload: message,
  };
};

const loadMeterHistoryRequest = (onApplyClick) => {
  return {
    type: LOAD_METER_HISTORY_REQUEST,
    onApplyClick : onApplyClick
  };
};

const loadMeterHistorySuccess = (result, onApplyClick) => {
  return {
    type: LOAD_METER_HISTORY_SUCCESS,
    payload: result,
    newState: { meterZipUploadHistoryList: result, onApplyClick: onApplyClick }
  };
};

const loadMeterHistoryError = (err) => {
  let message = GENERIC_FAILED_ERROR;
  if (err?.status == 500) {
    message = err?.responseJSON?.message || GENERIC_MESSAGE;
  } else if (err?.status == 400) {
    message = err?.responseJSON?.result || GENERIC_MESSAGE;
  }
  return {
    type: LOAD_METER_HISTORY_ERROR,
    payload: message,
  };
};

export const meterUploadHistoryFiltersAndZipSizeLimit = (url) => {
  return (dispatch) => {
    function callBack(success, err) {
      if (success && success.result) {
        let instances = success.result.meterUploadInstancesList;
        let serialNumbers = success.result.meterUploadSerialNumbersList || [];
        let fileSizeFromConfig = success.result.allowedZipSize || 1024;
        const instancesList = instances.map((item) => ({
          label: item,
          value: item,
        }));
        const serialNumbersList = serialNumbers.map((item) => ({
          label: item,
          value: item,
        }));
        dispatch({
          type: METER_UPLOAD_INSTANCE_LIST_AND_ZIP_SIZE_LIMIT,
          newState: { meterUploadsInstances: instancesList, meterUploadsSerialNumbers: serialNumbersList, zipFileSizeFromConfig: fileSizeFromConfig },
        });
      }
    }
    AppService.getData(url, callBack);
  };
};
